import { Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getBgColor } from '../utils/utils';
import { ColorRing } from 'react-loader-spinner';
import { selectSelectedCell } from '../redux/slices/higherOrderSlice';
import { useSelector } from 'react-redux';
const PriceComponent = ({ 
  title, 
  data, 
  roundIfFloat, 
  metric, 
  priceMovementColorKeys, 
  allpriceMovementClarityRanges, 
  priceMovementClarityDatas, 
  min, 
  max, 
  invertColors = false, 
  onCellClick, 
  hoveredCell, 
  onCellHover, 
  defaultTurn,
  isChangingShapeOrCarat,
  handleCellClick
  
}) => {
  // Keep a stable copy of data to prevent flickering
  const selectedCell = useSelector(selectSelectedCell)
  const getCellStyle = (color, clarity) => {
    const isSelected = selectedCell?.color === color && selectedCell?.clarity === clarity;
    return {
      color: "#000",
      border: isSelected ? "2px solid #000" : "1px solid #ccc",
      // position: "relative",
      // transition: "all 0.2s ease",
      // boxShadow: isSelected ? "0 0 8px rgba(0,0,0,0.3)" : "none",
      // transform: isSelected ? "scale(1.05)" : "scale(1)"
    };
  };
  // Update stable data only when data is fully loaded
  
  // Calculate min/max for inventory overhang
  const calculateMinMax = () => {
    if (metric === "overhang" && priceMovementClarityDatas) {
      const validValues = priceMovementClarityDatas.flat().filter(cell =>
        cell && cell[metric] !== 0 &&
        cell[metric] !== "NA" &&
        cell[metric] !== null &&
        cell[metric] !== undefined
      ).map(cell => cell[metric]);
      
      return {
        calculatedMin: validValues.length > 0 ? Math.min(...validValues) : min,
        calculatedMax: validValues.length > 0 ? Math.max(...validValues) : max
      };
    }
    
    return { calculatedMin: min, calculatedMax: max };
  };

  const { calculatedMin, calculatedMax } = calculateMinMax();
  const neutralValue = metric === "overhang" ? 80 : 0;
  const shouldInvertColors = metric === "overhang" ? true : invertColors;

  // Don't render data during loading or transitions
  if (isChangingShapeOrCarat) {
    return (
      <div className="flex justify-center items-center h-full">
                <ColorRing
                  visible={true}
                  height="70"
                  width="70"
                  ariaLabel="loading-indicator"
                  colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
                />
      </div>
    );
  }

  return (
    <div className='flex flex-col w-full h-full'>
      <h3 className='text-center text-inherit text-2xl font-medium'>{title}</h3>
      <div className="w-full overflow-x-auto">
          <table className="grid-shape-size self-center">
            <thead style={{ zIndex: 1 }}>
              <tr className="bg-gray-200">
                <th style={{ width: "55px" }} className="border border-gray-300">Col / Clar</th>
                {priceMovementColorKeys.length > 0 &&
                  Object.keys(data.data[priceMovementColorKeys[0]] || {})
                    .filter(key => key !== 'trans')
                    .map((clarity) => (
                      <th key={clarity}>
                        {data.data[priceMovementColorKeys[0]][clarity]?.trans || clarity}
                      </th>
                    ))
                }
              </tr>
            </thead>
            <tbody>
              {priceMovementColorKeys.map((color, rowIndex) => (
                <tr key={color}>
                  <td style={{ width: "10%", cursor: "pointer" }}>
                    {data.data[color]?.trans}
                  </td>
                  {allpriceMovementClarityRanges.map((clarity, colIndex) => {
                    const cellData = priceMovementClarityDatas?.[rowIndex]?.[colIndex]?.[metric] || 0;
                    const overhangData = priceMovementClarityDatas?.[rowIndex]?.[colIndex]?.["overhang"] || 0;
                    const bgColor = getBgColor(
                      calculatedMin, 
                      calculatedMax, 
                      cellData, 
                      neutralValue, 
                      60, 
                      shouldInvertColors
                    );
                    
                    const isHighlighted = hoveredCell &&
                      hoveredCell.column === colIndex &&
                      hoveredCell.row === rowIndex;

                    
                    return (
                      <Tooltip 
                        key={`${clarity}-${color}`} 
                        arrow 
                        placement="right-start" 
                        disableInteractive
                      >
                        <td
                          key={clarity}
                          
                          style={{
                            height: "52.3px",
                            minWidth: "48.4px",
                            color: "#000",
                            border: selectedCell?.color === color && selectedCell?.clarity === clarity ? "2px solid #000" : "1px solid #ccc",
                            padding: "0",
                            margin: "0 auto",
                            maxWidth: "55px",
                            backgroundColor: bgColor,
                            outline: isHighlighted ? "1px solid black " : "none",
                            outlineOffset: "-1px",
                            boxShadow: "none",
                            fontWeight: "normal",
                          }}
                          onClick={() => handleCellClick(rowIndex, colIndex)}
                          onMouseEnter={() => onCellHover(colIndex, rowIndex)}
                          onMouseLeave={() => onCellHover(null, null)}
                        >
                          {cellData === null || cellData === undefined || cellData === "NA"
                            ? "-"
                            : ((overhangData === "NA" || overhangData === 0) && cellData === 0) ? "-": roundIfFloat(cellData)}
                        </td>
                      </Tooltip>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    </div>
  );
};

export default PriceComponent;